/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents an object to wrap notification log.
 */
export interface NotificationLogModel { 
    /**
     * Notification body.
     */
    body: string;
    /**
     * Notification log ID.
     */
    id: number;
    /**
     * Determines if the notification log is already read or not.
     */
    read: boolean;
    /**
     * UTC date when the notification was sent.
     */
    sentAtUtc: string;
    /**
     * Notification title.
     */
    title: string;
}

